import api from './api';

export const productService = {
  getAll: (params) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  getMyProducts: (params) => api.get('/products/my', { params }),
  getBySeller: (username, params) => api.get(`/products/seller/${username}`, { params }),
  getSellerCategories: (username) => api.get(`/products/seller/${username}/categories`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  updateStatus: (id, status) => api.patch(`/products/${id}/status`, { status }),
  delete: (id) => api.delete(`/products/${id}`),
  toggleInterest: (id) => api.post(`/products/${id}/interest`),
  getInterested: (id) => api.get(`/products/${id}/interests`),
  sellTo: (id, buyerUsername) => api.post(`/products/${id}/sell`, buyerUsername ? { buyerUsername } : {}),
  unsell: (id) => api.post(`/products/${id}/unsell`),
  getMyInterests: (params) => api.get('/products/interests/my', { params }),
  getMyStockProducts: (params) => api.get('/products/my/stock', { params }),
  updateStock: (id, stock) => api.patch(`/products/${id}/stock`, { stock }),
  bulkUpdateStock: (data) => api.post('/products/my/stock/bulk', data),
  bulkChangeStatus: (data) => api.post('/products/my/status/bulk', data),
};
